export default "__VITE_ASSET__oS_hpPQM__"